import { Button } from '@/shared/ui/button';
import { ZoomIn, ZoomOut, Home } from 'lucide-react';

interface ZoomControlsProps {
  zoom: (factor: number) => void;
  reset: () => void;
}

const ZoomControls = ({ zoom, reset }: ZoomControlsProps) => {
  return (
    <div className="flex border rounded-lg overflow-hidden">
      <Button variant="ghost" size="sm" onClick={() => zoom(1.2)} className="rounded-none border-r">
        <ZoomIn className="h-4 w-4" />
      </Button>
      <Button variant="ghost" size="sm" onClick={() => zoom(0.8)} className="rounded-none border-r">
        <ZoomOut className="h-4 w-4" />
      </Button>
      <Button variant="ghost" size="sm" onClick={reset} className="rounded-none">
        <Home className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default ZoomControls;
